module.exports = __webpack_public_path__ + "img/yiliao.60b1ccf0.png";